module.exports = __webpack_public_path__ + "img/dentaire.e93da5ea.png";